'use strict';
var searchPartMixin = require('od-modules/mixins/searchpart.mixin');
var MDItemModel = require('./multi_destination_item.model');
var MDItemView = require('./multi_destination_item.view');
var ItemCollection = Backbone.Collection.extend({model: MDItemModel});
var FocusHandler = require('./focus_handler');

Odigeo.defineWidget('itinerary_md_search_manager', Odigeo.Widget.extend({

    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        defaults: {
            searchSegments: [],
        },
    })),

    viewClass: Odigeo.View.extend({
        templateSettings: Odigeo.Utils.getTmplSettings({variable: ''}),

        selectors: {
            itemsWrapper: '.oneline_md_items_wrapper',
            itemTemplate: '#multiple_destination_item',
            airportTemplate: Odigeo.AB.isCssVariationHeaderDesktop ?
                '#airport_selector_template_cobalt_variation' :
                '#airport_selector_template',
            airportAutoCompleteTemplateCobalt: '#airport_autocomplete_template_cobalt',
            airportAutoCompleteTemplate: '#airport_autocomplete_template',
            airportAutoCompleteTemplateZero: Odigeo.AB.isCssVariationHeaderDesktop ?
                '#airport_autocomplete_zero_results_cobalt_variation' :
                '#airport_autocomplete_zero_results',
            dateTemplate: Odigeo.AB.isCssVariationHeaderDesktop ?
                '#date_selector_template_cobalt_variation' :
                '#date_selector_template',
            addLeg: '.oneline_md_item_wrapper',
        },

        init: function() {
            this.options = Odigeo.parseOptions(this.widget.options);
            this.loadTemplates();
            this.items = new ItemCollection();

            this.listenTo(this.model, 'sync:fetch', this.reload);
            this.model.listenSearchModelProperty('type', Odigeo._.bind(this.reload, this));
            Odigeo.on('OneLinerMultiDestination:add', Odigeo._.bind(this.addItem, this));
            Odigeo.on('OneLinerMultiDestination:remove', Odigeo._.bind(this.removeItem, this));

            this.childrenView = [];
            this.focusHandler = new FocusHandler(this.childrenView);
            this.model.listenSearchModelProperty('type', Odigeo._.bind(this.onChildFulfilled, this));
        },

        toggleAddLeg: function() {
            var numSegments = Odigeo._.size(this.model.getOriginalData().searchSegments);
            var hideAddExtra = numSegments + 1 > this.options.maxLegs;
            this.$cachedSelectors.addLeg.toggleClass('odf-hidden', hideAddExtra);
        },

        addItem: function() {
            var searchSegments = this.model.getOriginalData().searchSegments || [];
            var numLegs = searchSegments.length;

            this.toggleAddLeg();

            if (numLegs < this.options.maxLegs) {
                var lastSegment = searchSegments[numLegs - 1];
                searchSegments.push({
                    departure: lastSegment.destination,
                    searchSubmit: false,
                });
                this.model.setSearchModelProperty('searchSegments', searchSegments);
                this.reload();
                this.focusHandler.setFocus();
            }
        },

        removeItem: function(index) {
            var searchSegments = this.model.getOriginalData().searchSegments || [];
            var numLegs = searchSegments.length;
            if (numLegs > 1) {
                searchSegments.splice(index, 1);
                this.model.setSearchModelProperty('searchSegments', searchSegments);
                this.reload();
                this.copyDestinationToNextOrigin();
                this.focusHandler.setFocus();
            }
        },

        loadTemplates: function() {
            const $autoCompleteTemplate = Odigeo.AB.isCssVariationHeaderDesktop
                ? this.$cachedSelectors.airportAutoCompleteTemplateCobalt
                : this.$cachedSelectors.airportAutoCompleteTemplate;

            this.tmpl = {
                main: Odigeo._.template(this.$cachedSelectors.itemTemplate.html(), this.templateSettings),
                airport: Odigeo._.template(this.$cachedSelectors.airportTemplate.html(), this.templateSettings),
                autoComplete: Odigeo._.template($autoCompleteTemplate.html(), this.templateSettings),
                autoCompleteZero: Odigeo._.template(this.$cachedSelectors.airportAutoCompleteTemplateZero.html(), this.templateSettings),
                date: Odigeo._.template(this.$cachedSelectors.dateTemplate.html(), this.templateSettings),
            };
        },

        reload: function() {
            var data = this.model.getOriginalData();
            var type = data.type;
            var searchSegments = data.searchSegments || [];
            if (searchSegments.length && type === 'multipleTrip') {
                this.items.reset(searchSegments);
                if (data.editsearch) {
                    var numLegs = searchSegments.length;
                    var maxLegs = this.widget.options.maxLegs;
                    Odigeo.trigger('OneLinerMultiDestination:changeLegsMD', numLegs, numLegs < maxLegs);
                }
                this.render();
            }
        },

        render: function() {
            Odigeo.UIElements.calendar = null;
            this.$cachedSelectors.itemsWrapper.empty();
            this.childrenView.length = 0;
            this.items.forEach(this.renderItem, this);
            this.toggleAddLeg();

            return this;
        },

        renderItem: function(itemModel, index) {
            var view = new MDItemView({
                model: itemModel,
                index: index,
                templates: this.tmpl,
                hideDeleteButton: index < 2,
                dateFormat: this.widget.options.dateFormat,
            });
            this.$cachedSelectors.itemsWrapper.append(view.el);
            this.childrenView.push(view);

            this.bindItem(view);
        },

        bindItem: function(view) {
            this.listenTo(view.model, 'change:dateStr', Odigeo._.bind(this.clearDates, this));
            this.listenTo(view.model, 'change', Odigeo._.bind(this.updateSearchSegments, this));
            view.on('fulfilled', Odigeo._.bind(this.onChildFulfilled, this));
        },

        clearDates: function() {
            var maxDate = 0;

            this.items.forEach(function(segment) {
                var dateStr = segment.get('dateStr');
                var date = dateStr ? Odigeo.Utils.parseDate(dateStr) : false;

                if (date && date >= maxDate) {
                    maxDate = date;
                } else {
                    segment.set('dateStr', null);
                }
            });
        },

        updateSearchSegments: function() {
            if (this.model.getOriginalData().type === 'multipleTrip') {
                this.copyDestinationToNextOrigin();

                var segments = this.items.map(function(item) {
                    return item.toJSON();
                });

                this.model.setSearchModelProperty('searchSegments', segments);
            }
        },

        copyDestinationToNextOrigin: function() {
            this.items.forEach(Odigeo._.bind(function(segment, index) {
                if (index && !segment.get('departure') && this.items.at(index-1).get('destination')) {
                    segment.set('departure', this.items.at(index-1).get('destination'));
                }
            }, this));
        },

        onChildFulfilled: function() {
            this.focusHandler.onChildFulfilled();
        },
    }),

}));
